<script>
	export let value = '';
	export let minRows = 1;
	export let maxRows;
	
	$: minHeight = `${ minRows * 1.2}em`;
	$: maxHeight = maxRows ? `${ maxRows * 1.2}em` : `auto`;
</script>

<div class="container">
	<pre
		aria-hidden="true"
		style="min-height: {minHeight}; max-height: {maxHeight}"
	>{value}</pre>

	<textarea bind:value></textarea>	
</div>

<style>
	.container {
		position: relative;
	}
	
	pre, textarea {
		font-family: inherit;
		padding: 0.5em;
		box-sizing: border-box;
		border: 1px solid #eee;
		line-height: 1.2;
		overflow: hidden;
        border-radius: 12px;
	}

	pre {
		opacity: 0.0;
	}
	
	textarea {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		resize: none;
	}

    textarea {
        display: flex;
        flex-direction: column;
        width: 100%;
        /* flex-basis: auto; */
        /* justify-content: stretch; */
        flex-grow: 5;
        background-color: rgba(255,255,255,0.07);
        border: 1px solid rgba(255,255,255,0.1);
        border-radius: 5px;
        color: var(--text-color);
        overflow: hidden;
        font-family: monospace;
        font-size: 0.9rem;

    }

    textarea:focus {
        border: none;
        overflow: auto;
        outline: none;
        box-shadow: none;
        resize: none; /*remove the resize handle on the bottom right*/
		border: 1px solid rgba(255,255,255,0.5);
    }

</style>